// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
let models = [
  {
    name: "GPT-6 Astra",
    desc: "星轨级旗舰推理引擎，为最艰巨的端到端任务而生\n全模态·超高性能，覆盖复杂项目、长程任务、\n高价值工作、网络安全与科研需求",
    nameEn: "GPT-6 Astra",
    descEn:
      "A star-track flagship reasoning engine, built for the most demanding end-to-end tasks.\nFull modality, top-tier performance — covering complex projects, long-horizon tasks, high-stakes work, cybersecurity, and research.",
    image: "/" + "static/gpt6astra.png",
    redirectUrl: "https://developers.openai.com/api/docs/models/gpt-6-astra",
    pricing: [
      {
        labelKey: "gpt-6-astra.pricing.inputCacheHit",
        priceKey: "gpt-6-astra.pricing.inputCacheHitPrice",
        unitKey: "gpt-6-astra.pricing.unit",
      },
      {
        labelKey: "gpt-6-astra.pricing.inputCacheMiss",
        priceKey: "gpt-6-astra.pricing.inputCacheMissPrice",
        unitKey: "gpt-6-astra.pricing.unit",
      },
      {
        labelKey: "gpt-6-astra.pricing.output",
        priceKey: "gpt-6-astra.pricing.outputPrice",
        unitKey: "gpt-6-astra.pricing.unit",
      },
    ],
  },
  {
    name: "Claude Opus 5.5",
    desc: "长程智能体编码与知识工作的日常驱动者\n以更少 token 完成更多任务，成本较前代骤降 40%",
    nameEn: "Claude Opus 5.5",
    descEn:
      "The everyday driver for long-horizon agentic coding and knowledge work.\nMore done with fewer tokens, at 40% lower cost than the previous generation.",
    image: "/" + "static/claudeopus5-5.png",
    redirectUrl: "https://www.anthropic.com/claude/opus",
    pricing: [
      {
        labelKey: "claude-opus-5-5.pricing.inputCacheHit",
        priceKey: "claude-opus-5-5.pricing.inputCacheHitPrice",
        unitKey: "claude-opus-5-5.pricing.unit",
      },
      {
        labelKey: "claude-opus-5-5.pricing.inputCacheMiss",
        priceKey: "claude-opus-5-5.pricing.inputCacheMissPrice",
        unitKey: "claude-opus-5-5.pricing.unit",
      },
      {
        labelKey: "claude-opus-5-5.pricing.output",
        priceKey: "claude-opus-5-5.pricing.outputPrice",
        unitKey: "claude-opus-5-5.pricing.unit",
      },
    ],
  },
  {
    name: "Kimi K3",
    desc: "百万上下文的智能新前沿，深度推理的旗舰之作\nMooncake 分离式推理架构，编程场景缓存率超 90%，\n实际输入成本仅为标准价的四分之一",
    nameEn: "Kimi K3",
    descEn:
      "A new frontier in intelligence with a million-token context, and a flagship of deep reasoning.\nBuilt on the Mooncake disaggregated inference architecture, with cache hit rates above 90% in coding scenarios — real input cost is just a quarter of list price.",
    image: "/" + "static/kimik3.png",
    redirectUrl: "https://www.kimi.com/ai-models/kimi-k3",
    pricing: [
      {
        labelKey: "kimi-k3.pricing.inputCacheHit",
        priceKey: "kimi-k3.pricing.inputCacheHitPrice",
        unitKey: "kimi-k3.pricing.unit",
      },
      {
        labelKey: "kimi-k3.pricing.inputCacheMiss",
        priceKey: "kimi-k3.pricing.inputCacheMissPrice",
        unitKey: "kimi-k3.pricing.unit",
      },
      {
        labelKey: "kimi-k3.pricing.output",
        priceKey: "kimi-k3.pricing.outputPrice",
        unitKey: "kimi-k3.pricing.unit",
      },
    ],
  },
  {
    name: "DeepSeek-V4.1-Flash",
    desc: "以 Pro 之能，收 Flash 之价的普惠推理之光\n百万上下文·384K 输出，思考与非思考双模并行\n峰谷动态定价，让算力随潮汐呼吸",
    nameEn: "DeepSeek-V4.1-Flash",
    descEn:
      "Pro-grade capability at Flash pricing — accessible reasoning for everyone.\nA million-token context and 384K output, with thinking and non-thinking modes running in parallel.\nDynamic peak/off-peak pricing, letting compute breathe with the tide.",
    image: "/" + "static/deeepseek-v4.1-flash.png",
    redirectUrl: "https://www.deepseek.com/en/news/deepseek-v4-1-flash",
    pricing: [
      {
        labelKey: "deepseek-v4-1-flash.pricing.inputCacheHit",
        priceKey: "deepseek-v4-1-flash.pricing.inputCacheHitPrice",
        unitKey: "deepseek-v4-1-flash.pricing.unit",
      },
      {
        labelKey: "deepseek-v4-1-flash.pricing.inputCacheMiss",
        priceKey: "deepseek-v4-1-flash.pricing.inputCacheMissPrice",
        unitKey: "deepseek-v4-1-flash.pricing.unit",
      },
      {
        labelKey: "deepseek-v4-1-flash.pricing.output",
        priceKey: "deepseek-v4-1-flash.pricing.outputPrice",
        unitKey: "deepseek-v4-1-flash.pricing.unit",
      },
    ],
  },
];
export { models };
